import { useState, useEffect, useCallback } from "react";
import Select, { ActionMeta } from "react-select";
import { combineLatestInit } from "rxjs/internal/observable/combineLatest";
import * as APIModels from "../../../models";
import { JudicialOfficerDetailedResponse } from "../../../models/swagger/generated-data-service";
import { DataService } from "../../../services/DataService";
import { CoversheetService } from "../../../services/SubmissionService";
import CoversheetModal from "../modals/CoversheetModal";
import { stat } from "fs";

type MyOptionType = { label: string; value: string };
type MyCourtOptionType = {
    label: string;
    value: APIModels.CoversheetCourtType;
};

type MyCoversheetOptionType = {
    label: string;
    value: APIModels.CoversheetSave;
};

export type CoversheetProps = {
    coversheet: APIModels.Coversheet;
    onComplete: (completeCoversheet: APIModels.Coversheet) => void;
    attorneyId: string;
};

export default function Coversheet({
    coversheet,
    onComplete,
    attorneyId,
}: CoversheetProps) {
    const [completeCoversheet, setCompleteCoversheet] = useState(coversheet);
    const [coversheetSave, setCoversheetSave] = useState(
        new APIModels.CoversheetSave()
    );
    const newCoversheetOption: MyCoversheetOptionType = {
        label: "New",
        value: new APIModels.CoversheetSave(),
    };
    const [loadedCoversheetSave, setLoadedCoverSheetSave] = useState(false);
    const [reload, setReload] = useState(false);

    const [coversheetSaveOptions, setCoversheetSaveOptions] = useState(
        [] as MyCoversheetOptionType[]
    );

    const [modalShow, setModalShow] = useState(false);

    const [stateId, setStateId] = useState("");
    const [stateOptions, setStateOptions] = useState([] as MyOptionType[]);
    const [courtTypeName, setCourtTypeName] = useState("");
    const [courtType, setCourtType] = useState(
        new APIModels.CoversheetCourtType()
    );
    const [courtTypeOptions, setCourtTypeOptions] = useState(
        [] as MyCourtOptionType[]
    );

    const [caseTypeId, setCaseTypeId] = useState("");
    const [caseTypeOptions, setCaseTypeOptions] = useState(
        [] as MyOptionType[]
    );

    const [caseSubTypeId, setCaseSubTypeId] = useState("");
    const [caseSubTypeOptions, setCaseSubTypeOptions] = useState(
        [] as MyOptionType[]
    );

    const [errorMessage, setErrormessage] = useState("");

    const [defendants, setDefendats] = useState(
        completeCoversheet.numberOfDefendants
    );

    useEffect(() => {
        CoversheetService.getList({ attorneyId: attorneyId }).then(
            (resp) => {
                const options = resp!.data!.map((v, i) => {
                    return { value: v, label: v.name! };
                });
                setCoversheetSaveOptions([newCoversheetOption, ...options]);
            },
            (error) => {
                console.log(error);
            }
        );

        DataService.getStates().then(
            (resp) => {
                const options = resp.map((v, i) => {
                    return { value: v.abbreviation!, label: v.name! };
                });
                setStateOptions(options);
            },
            (error) => {
                console.log(error);
            }
        );
    }, []);

    useEffect(() => {
        if (stateId !== "") {
            DataService.getCoversheetCourtTypes({ state: stateId }).then(
                (resp) => {
                    const options = resp.map((v, i) => {
                        return { value: v, label: v.name! };
                    });
                    setCourtTypeOptions(options);

                    if (loadedCoversheetSave) {
                        setCourtType(
                            options[
                                options.findIndex(
                                    (c) =>
                                        c.label ==
                                        coversheetSave!.coversheet!
                                            .coversheetCourtType!
                                )
                            ].value
                        );
                    }
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    }, [stateId, reload]);

    useEffect(() => {
        if (courtType.id !== "" && courtType.id != undefined) {
            DataService.getCoversheetCaseTypes({
                courtTypeId: courtType.id!,
            }).then(
                (resp) => {
                    const options = resp.map((v, i) => {
                        return { value: v.id!, label: v.name! };
                    });

                    setCaseTypeOptions(options);
                    if (loadedCoversheetSave) {
                        if (options.length > 0) {
                            setCaseTypeId(
                                options[
                                    options.findIndex(
                                        (c) =>
                                            c.label ==
                                            coversheetSave!.coversheet!
                                                .coversheetCaseType!
                                    )
                                ].value
                            );
                        }
                    }
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    }, [courtType]);

    useEffect(() => {
        if (caseTypeId !== "" && caseTypeId != undefined) {
            DataService.getCoversheetCaseSubTypes({
                caseTypeId: caseTypeId,
            }).then(
                (resp) => {
                    const options = resp.map((v, i) => {
                        return { value: v.id!, label: v.name! };
                    });
                    setCaseSubTypeOptions(options);
                    if (loadedCoversheetSave) {
                        if (options.length > 0) {
                            setCaseSubTypeId(
                                options[
                                    options.findIndex(
                                        (c) =>
                                            c.label ==
                                            coversheetSave!.coversheet!
                                                .coversheetCaseSubType!
                                    )
                                ].value
                            );
                        }
                    }
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    }, [caseTypeId, courtType]);

    const clearCoversheet = () => {
        setLoadedCoverSheetSave(false);

        setCompleteCoversheet(new APIModels.Coversheet());
        setCoversheetSave(new APIModels.CoversheetSave());
        //setStateId("");
        setCourtType(new APIModels.CoversheetCourtType());
        setCaseTypeId("");
        setCaseSubTypeId("");
        setCourtTypeOptions([]);
        setCaseTypeOptions([]);
        setCaseSubTypeOptions([]);
    };

    const onStateChange = (
        value: MyOptionType | null,
        actionMeta: ActionMeta<MyOptionType>
    ) => {
        setStateId(value?.value ?? "");
        setLoadedCoverSheetSave(false);
        clearCoversheet();

        //setCoversheetSave({ ...coversheetSave, state: value?.value });
    };

    const onCourtTypeChange = (
        value: MyCourtOptionType | null,
        actionMeta: ActionMeta<MyCourtOptionType>
    ) => {
        setCaseTypeId("");
        setCaseSubTypeId("");
        setCaseTypeOptions([]);
        setCaseSubTypeOptions([]);
        setCourtType(value!.value);
        setLoadedCoverSheetSave(false);
        setCompleteCoversheet({
            ...completeCoversheet,
            coversheetCourtType: value?.value.name,
        });
    };

    const onCaseTypeChange = (
        value: MyOptionType | null,
        actionMeta: ActionMeta<MyOptionType>
    ) => {
        setCaseTypeId(value?.value ?? "");
        setLoadedCoverSheetSave(false);
        setCompleteCoversheet({
            ...completeCoversheet,
            coversheetCaseType: value?.label,
        });
    };

    const onCaseSubTypeChange = (
        value: MyOptionType | null,
        actionMeta: ActionMeta<MyOptionType>
    ) => {
        setCaseSubTypeId(value?.value ?? "");
        setLoadedCoverSheetSave(false);
        setCompleteCoversheet({
            ...completeCoversheet,
            coversheetCaseSubType: value?.label,
        });
    };

    const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (validateForm() == true) {
            onComplete(completeCoversheet);
        } else {
            console.log("Error validating");
        }
    };

    const filterOption = (option: MyOptionType, inputValue: string): boolean =>
        (
            option.label
                .toString()
                .toLowerCase()
                .match(inputValue.toLowerCase()) || []
        ).length > 0;

    const validateForm = () => {
        const state = stateOptions.find((c) => c.value === stateId)?.label;

        if (state == "Florida") {
            setErrormessage("");
            if (completeCoversheet.causesOfAction === undefined) {
                setCompleteCoversheet({
                    ...completeCoversheet,
                    causesOfAction: 1,
                });
            }
            if (!stateId) {
                setErrormessage(
                    "Please select a State from the drop down menu."
                );
            } else if (!courtType.id) {
                setErrormessage(
                    "Please select a Court from the drop down menu."
                );
            } else if (
                !completeCoversheet.monetary &&
                !completeCoversheet.nonMonetary &&
                !completeCoversheet.relief &&
                !completeCoversheet.punitive
            ) {
                setErrormessage(
                    "Please select at least one check box from Remedies Sought."
                );
            } else if (
                completeCoversheet.hasRelatedCases == undefined &&
                state == "Florida"
            ) {
                setErrormessage("Please select Yes or No for Related Cases.");
            } else if (completeCoversheet.classAction == undefined) {
                setErrormessage("Please select Yes or No for Class Action.");
            } else if (completeCoversheet.juryTrial == undefined) {
                setErrormessage("Please select Yes or No for Jury Trial.");
            } else if (completeCoversheet.complexBusinessCourt == undefined) {
                setErrormessage(
                    "Please select Yes or No for Complex Business Court."
                );
            } else if (completeCoversheet.numberOfDefendants == undefined) {
                setErrormessage("Please select Number of Defendants.");
            } else if (completeCoversheet.numberOfSubpoenas == undefined) {
                setErrormessage("Please select Number of Subpoenas.");
            } else if (
                completeCoversheet.monetary === true &&
                (completeCoversheet.claimAmount! < courtType.minAmount! ||
                    completeCoversheet.claimAmount! > courtType.maxAmount!)
            ) {
                setErrormessage(
                    "For " +
                        courtType.name +
                        " court, enter a claim amount between " +
                        courtType.minAmount +
                        " and " +
                        courtType.maxAmount +
                        "."
                );
            } else if (!caseTypeId) {
                setErrormessage(
                    "Please select a Case Type from the drop down menu."
                );
            } else if (
                caseTypeId &&
                caseSubTypeOptions.length > 0 &&
                !caseSubTypeId
            ) {
                setErrormessage(
                    "Please select a Case Sub Type from the drop down menu."
                );
            } else if (
                completeCoversheet.claimAmount! &&
                completeCoversheet.claimAmount == 100
            ) {
                setErrormessage(
                    "Please either enter $99 or $101. For the tier you are filing in."
                );
            } else if (
                completeCoversheet.claimAmount! &&
                completeCoversheet.claimAmount == 500
            ) {
                setErrormessage(
                    "Please either enter $499 or $501. For the tier you are filing in."
                );
            } else if (
                completeCoversheet.claimAmount! &&
                completeCoversheet.claimAmount == 2500
            ) {
                setErrormessage(
                    "Please either enter $2499 or $2501. For the tier you are filing in."
                );
            } else if (
                completeCoversheet.claimAmount! &&
                completeCoversheet.claimAmount == 5000
            ) {
                setErrormessage(
                    "Please either enter $4999 or $5001. For the tier you are filing in."
                );
            } else {
                return true;
            }
        } else {
            if (!stateId) {
                setErrormessage(
                    "Please select a State from the drop down menu."
                );
            } else if (!courtType.id) {
                setErrormessage(
                    "Please select a Court from the drop down menu."
                );
            } else if (!caseTypeId) {
                setErrormessage(
                    "Please select a Case Type from the drop down menu."
                );
            } else if (
                caseTypeId &&
                caseSubTypeOptions.length > 0 &&
                !caseSubTypeId
            ) {
                setErrormessage(
                    "Please select a Case Sub Type from the drop down menu."
                );
            } else if (completeCoversheet.claimAmount! <= 0) {
                setErrormessage("Please enter a valid Claim Amount.");
            } else {
                return true;
            }
        }

        return false;
    };

    const onSave = () => {
        if (validateForm() == true) {
            setCoversheetSave({
                ...coversheetSave,
                coversheet: completeCoversheet,
                attorneyID: attorneyId,
                state: stateId,
                name: coversheetSave.name,
                id: coversheetSave.id,
            });

            setModalShow(true);
        } else {
            console.log("Error validating form");
        }
    };

    const onCoversheetChange = (
        value: MyCoversheetOptionType | null,
        actionMeta: ActionMeta<MyCoversheetOptionType>
    ) => {
        if (value?.label === "New") {
            setLoadedCoverSheetSave(false);

            setCompleteCoversheet(new APIModels.Coversheet());
            setCoversheetSave(new APIModels.CoversheetSave());
            setStateId("");
            setCourtType(new APIModels.CoversheetCourtType());
            setCaseTypeId("");
            setCaseSubTypeId("");
            setCourtTypeOptions([]);
        } else {
            setLoadedCoverSheetSave(true);
            setReload(!reload);
            const newCoversheet = value!.value!.coversheet!;

            setStateId(value!.value!.state!);

            setCompleteCoversheet(newCoversheet);
            setCoversheetSave(value!.value!);
        }
    };

    return (
        <>
            <form className="needs-validation" onSubmit={onSubmit}>
                <CoversheetModal
                    show={modalShow}
                    coversheetSave={coversheetSave}
                    coversheetOptions={coversheetSaveOptions}
                    onConfirm={() => setModalShow(false)}
                    onCancel={() => setModalShow(false)}
                />
                <div className="row">
                    {" "}
                    <div className="col-sm-3 mb-3">
                        <div className="mt-3">
                            <label
                                htmlFor="selcoverSheettype"
                                className="form-label"
                            >
                                Coversheet
                            </label>
                            {loadedCoversheetSave === false ? (
                                <Select
                                    id="selcoverSheettype"
                                    name="selcoverSheettype"
                                    //defaultValue="NEW"
                                    //value={coversheetSaveOptions[0]}

                                    value={coversheetSaveOptions[0]}
                                    filterOption={filterOption}
                                    options={coversheetSaveOptions}
                                    onChange={(value, actionMeta) => {
                                        onCoversheetChange(value, actionMeta);
                                    }}
                                />
                            ) : (
                                <Select
                                    id="selcoverSheettype"
                                    name="selcoverSheettype"
                                    value={coversheetSaveOptions.filter(
                                        (c) => c.label === coversheetSave.name
                                    )}
                                    filterOption={filterOption}
                                    options={coversheetSaveOptions}
                                    onChange={(value, actionMeta) => {
                                        onCoversheetChange(value, actionMeta);
                                    }}
                                />
                            )}
                        </div>
                    </div>
                </div>
                {stateOptions.find((c) => c.value === stateId)?.label ==
                    "Florida" || stateId == "" ? (
                    <>
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="row">
                                    <div className="col-sm-8">
                                        <label
                                            htmlFor="selState"
                                            className="form-label"
                                        >
                                            State
                                        </label>
                                        <Select
                                            id="selState"
                                            name="selState"
                                            className="required"
                                            value={stateOptions.filter(
                                                (c) => c.value === stateId
                                            )}
                                            options={stateOptions}
                                            onChange={onStateChange}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-8">
                                        <label
                                            htmlFor="selCourtType"
                                            className="form-label"
                                        >
                                            Court
                                        </label>

                                        <Select
                                            id="selCourtType"
                                            name="selCourtType"
                                            value={courtTypeOptions.filter(
                                                (c) => c.value === courtType
                                            )}
                                            options={courtTypeOptions}
                                            onChange={onCourtTypeChange}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-sm-6">
                                <div className="mt-3">
                                    <h5 className="font-14 mb-2">
                                        {" "}
                                        Remedies Sought
                                    </h5>
                                    <div className="row checkbox-group required">
                                        <div className="col-sm-6">
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="ckMonetary"
                                                    checked={
                                                        completeCoversheet.monetary
                                                    }
                                                    onChange={(e) =>
                                                        setCompleteCoversheet({
                                                            ...completeCoversheet,
                                                            monetary:
                                                                e.currentTarget
                                                                    .checked,
                                                        })
                                                    }
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor="ckMonetary"
                                                >
                                                    Monetary
                                                </label>
                                            </div>
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value=""
                                                    id="ckInjRelief"
                                                    checked={
                                                        completeCoversheet.relief
                                                    }
                                                    onChange={(e) =>
                                                        setCompleteCoversheet({
                                                            ...completeCoversheet,
                                                            relief: e
                                                                .currentTarget
                                                                .checked,
                                                        })
                                                    }
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor="ckInjRelief"
                                                >
                                                    Declaratory or Injunctive
                                                    Relief
                                                </label>
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value=""
                                                    id="ckNonMonetary"
                                                    checked={
                                                        completeCoversheet.nonMonetary
                                                    }
                                                    onChange={(e) =>
                                                        setCompleteCoversheet({
                                                            ...completeCoversheet,
                                                            nonMonetary:
                                                                e.currentTarget
                                                                    .checked,
                                                        })
                                                    }
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor="ckNonMonetary"
                                                >
                                                    Non-monetary
                                                </label>
                                            </div>
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value=""
                                                    id="ckPunitive"
                                                    checked={
                                                        completeCoversheet.punitive
                                                    }
                                                    onChange={(e) =>
                                                        setCompleteCoversheet({
                                                            ...completeCoversheet,
                                                            punitive:
                                                                e.currentTarget
                                                                    .checked,
                                                        })
                                                    }
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor="ckPunitive"
                                                >
                                                    Punitive
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-3">
                                <div className="mt-3">
                                    <h5 className="font-14 mb-2">
                                        Related Cases?
                                    </h5>
                                    <div className="form-check">
                                        <div className="row">
                                            <div className="col-sm-3">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    id="btnYesRelatedCases"
                                                    name="relatedCases"
                                                    checked={
                                                        completeCoversheet.hasRelatedCases ===
                                                        true
                                                    }
                                                    onChange={(e) =>
                                                        setCompleteCoversheet({
                                                            ...completeCoversheet,
                                                            hasRelatedCases:
                                                                e.currentTarget
                                                                    .checked,
                                                        })
                                                    }
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor="btnYesRelatedCases"
                                                >
                                                    Yes
                                                </label>
                                            </div>
                                            <div className="col-sm-3">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    id="btnNoRelatedCases"
                                                    name="relatedCases"
                                                    checked={
                                                        completeCoversheet.hasRelatedCases ===
                                                        false
                                                    }
                                                    onChange={(e) =>
                                                        setCompleteCoversheet({
                                                            ...completeCoversheet,
                                                            hasRelatedCases:
                                                                !e.currentTarget
                                                                    .checked,
                                                        })
                                                    }
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor="btnNoRelatedCases"
                                                >
                                                    No
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-3">
                                <div className="mt-3">
                                    <h5 className="font-14 mb-2">
                                        Class Action?
                                    </h5>
                                    <div className="form-check">
                                        <div className="row">
                                            <div className="col-sm-3">
                                                {" "}
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    id="rbYesClassAction"
                                                    name="classAction"
                                                    checked={
                                                        completeCoversheet.classAction ===
                                                        true
                                                    }
                                                    onChange={(e) =>
                                                        setCompleteCoversheet({
                                                            ...completeCoversheet,
                                                            classAction:
                                                                e.currentTarget
                                                                    .checked,
                                                        })
                                                    }
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor="rbYesClassAction"
                                                >
                                                    Yes
                                                </label>
                                            </div>
                                            <div className="col-sm-3">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    id="rbNoClassAction"
                                                    name="classAction"
                                                    checked={
                                                        completeCoversheet.classAction ===
                                                        false
                                                    }
                                                    onChange={(e) =>
                                                        setCompleteCoversheet({
                                                            ...completeCoversheet,
                                                            classAction:
                                                                !e.currentTarget
                                                                    .checked,
                                                        })
                                                    }
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor="rbNoClassAction"
                                                >
                                                    No
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-3">
                                <div className="mt-3">
                                    <h5 className="font-14 mb-2">
                                        Jury Trial?
                                    </h5>
                                    <div className="form-check">
                                        <div className="row">
                                            <div className="col-sm-3">
                                                {" "}
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    id="rbYesJury"
                                                    name="juryTrial"
                                                    checked={
                                                        completeCoversheet.juryTrial ===
                                                        true
                                                    }
                                                    onChange={(e) =>
                                                        setCompleteCoversheet({
                                                            ...completeCoversheet,
                                                            juryTrial:
                                                                e.currentTarget
                                                                    .checked,
                                                        })
                                                    }
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor="rbYesJury"
                                                >
                                                    Yes
                                                </label>
                                            </div>
                                            <div className="col-sm-3">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    id="rbNoJury"
                                                    name="juryTrial"
                                                    checked={
                                                        completeCoversheet.juryTrial ===
                                                        false
                                                    }
                                                    onChange={(e) =>
                                                        setCompleteCoversheet({
                                                            ...completeCoversheet,
                                                            juryTrial:
                                                                !e.currentTarget
                                                                    .checked,
                                                        })
                                                    }
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor="rbNoJury"
                                                >
                                                    No
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-3">
                                <div className="mt-3">
                                    <h5 className="font-14 mb-2">
                                        Complex Business Court?
                                    </h5>
                                    <div className="form-check">
                                        <div className="row">
                                            <div className="col-sm-3">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="flexRadioDefault"
                                                    id="rbYesComplexBusinessCourt"
                                                    checked={
                                                        completeCoversheet.complexBusinessCourt ===
                                                        true
                                                    }
                                                    onChange={(e) =>
                                                        setCompleteCoversheet({
                                                            ...completeCoversheet,
                                                            complexBusinessCourt:
                                                                e.currentTarget
                                                                    .checked,
                                                        })
                                                    }
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor="rbYesComplexBusinessCourt"
                                                >
                                                    Yes
                                                </label>
                                            </div>
                                            <div className="col-sm-3">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="flexRadioDefault"
                                                    id="rbNoComplexBusinessCourt"
                                                    checked={
                                                        completeCoversheet.complexBusinessCourt ===
                                                        false
                                                    }
                                                    onChange={(e) =>
                                                        setCompleteCoversheet({
                                                            ...completeCoversheet,
                                                            complexBusinessCourt:
                                                                !e.currentTarget
                                                                    .checked,
                                                        })
                                                    }
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor="rbNoComplexBusinessCourt"
                                                >
                                                    No
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-3">
                                <div className="mt-3">
                                    <h5 className="font-14 mb-2">
                                        Cause of Action
                                    </h5>
                                    <div className="form-check">
                                        {completeCoversheet.causesOfAction ===
                                        undefined ? (
                                            <input
                                                required={true}
                                                className="form-control"
                                                type="number"
                                                name="txtCauseOfAction"
                                                id="txtCauseOfAction"
                                                value={1}
                                                onChange={(e) =>
                                                    setCompleteCoversheet({
                                                        ...completeCoversheet,
                                                        causesOfAction:
                                                            parseInt(
                                                                e.currentTarget
                                                                    .value
                                                            ),
                                                    })
                                                }
                                            />
                                        ) : (
                                            <input
                                                required={true}
                                                className="form-control"
                                                type="number"
                                                name="txtCauseOfAction"
                                                id="txtCauseOfAction"
                                                value={
                                                    completeCoversheet.causesOfAction
                                                }
                                                onChange={(e) =>
                                                    setCompleteCoversheet({
                                                        ...completeCoversheet,
                                                        causesOfAction:
                                                            parseInt(
                                                                e.currentTarget
                                                                    .value
                                                            ),
                                                    })
                                                }
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-3">
                                <div className="mt-3">
                                    <h5 className="font-14 mb-2">Defendants</h5>
                                    <div className="form-check">
                                        <input
                                            required={true}
                                            className="form-control"
                                            type="number"
                                            name="txtDefendants"
                                            id="txtDefendants"
                                            value={
                                                completeCoversheet.numberOfDefendants ??
                                                ""
                                            }
                                            onChange={(e) =>
                                                setCompleteCoversheet({
                                                    ...completeCoversheet,
                                                    numberOfDefendants:
                                                        parseInt(
                                                            e.currentTarget
                                                                .value
                                                        ),
                                                })
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-3">
                                <div className="mt-3">
                                    <h5 className="font-14 mb-2">Subpoenas</h5>
                                    <div className="form-check">
                                        <input
                                            required={true}
                                            className="form-control"
                                            type="number"
                                            name="txtSubpoenas"
                                            id="txtSubpoenas"
                                            value={
                                                completeCoversheet.numberOfSubpoenas ??
                                                ""
                                            }
                                            onChange={(e) =>
                                                setCompleteCoversheet({
                                                    ...completeCoversheet,
                                                    numberOfSubpoenas: parseInt(
                                                        e.currentTarget.value
                                                    ),
                                                })
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-3">
                                <div className="mt-3">
                                    <h5 className="font-14 mb-2">
                                        Claim Amount
                                    </h5>
                                    <div className="form-check">
                                        {completeCoversheet.monetary ===
                                        true ? (
                                            <input
                                                required={true}
                                                className="form-control"
                                                type="number"
                                                name="txtClaimAmount"
                                                id="txtClaimAmount"
                                                value={
                                                    completeCoversheet.claimAmount ??
                                                    ""
                                                }
                                                onChange={(e) =>
                                                    setCompleteCoversheet({
                                                        ...completeCoversheet,
                                                        claimAmount: parseInt(
                                                            e.currentTarget
                                                                .value
                                                        ),
                                                    })
                                                }
                                            />
                                        ) : (
                                            ((completeCoversheet.claimAmount = 0),
                                            (
                                                <input
                                                    disabled
                                                    className="form-control"
                                                    type="number"
                                                    name="txtClaimAmount"
                                                    id="txtClaimAmount"
                                                    value={0}
                                                    onChange={(e) =>
                                                        setCompleteCoversheet({
                                                            ...completeCoversheet,
                                                            claimAmount:
                                                                parseInt(
                                                                    e
                                                                        .currentTarget
                                                                        .value
                                                                ),
                                                        })
                                                    }
                                                />
                                            ))
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="mt-3">
                                    <label
                                        htmlFor="selCaseType"
                                        className="form-label"
                                    >
                                        Case Type
                                    </label>

                                    <Select
                                        id="selCaseType"
                                        name="selCaseType"
                                        value={caseTypeOptions.filter(
                                            (c) => c.value === caseTypeId
                                        )}
                                        filterOption={filterOption}
                                        options={caseTypeOptions}
                                        onChange={onCaseTypeChange}
                                    />
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="mt-3">
                                    <label
                                        htmlFor="selCaseSubType"
                                        className="form-label"
                                    >
                                        Case Sub Type
                                    </label>
                                    <Select
                                        id="selCaseSubType"
                                        name="selCaseSubType"
                                        value={caseSubTypeOptions.filter(
                                            (c) => c.value === caseSubTypeId
                                        )}
                                        filterOption={filterOption}
                                        options={caseSubTypeOptions}
                                        onChange={onCaseSubTypeChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="row">
                                    <div className="col-sm-8">
                                        <label
                                            htmlFor="selState"
                                            className="form-label"
                                        >
                                            State
                                        </label>
                                        <Select
                                            id="selState"
                                            name="selState"
                                            className="required"
                                            value={stateOptions.filter(
                                                (c) => c.value === stateId
                                            )}
                                            options={stateOptions}
                                            onChange={onStateChange}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-8">
                                        <label
                                            htmlFor="selCourtType"
                                            className="form-label"
                                        >
                                            Court
                                        </label>

                                        <Select
                                            id="selCourtType"
                                            name="selCourtType"
                                            value={courtTypeOptions.filter(
                                                (c) => c.value === courtType
                                            )}
                                            options={courtTypeOptions}
                                            onChange={onCourtTypeChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-6">
                                <div className="mt-3">
                                    <label
                                        htmlFor="selCaseType"
                                        className="form-label"
                                    >
                                        Case Type
                                    </label>

                                    <Select
                                        id="selCaseType"
                                        name="selCaseType"
                                        value={caseTypeOptions.filter(
                                            (c) => c.value === caseTypeId
                                        )}
                                        filterOption={filterOption}
                                        options={caseTypeOptions}
                                        onChange={onCaseTypeChange}
                                    />
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="mt-3">
                                    <label
                                        htmlFor="selCaseSubType"
                                        className="form-label"
                                    >
                                        Case Sub Type
                                    </label>
                                    <Select
                                        id="selCaseSubType"
                                        name="selCaseSubType"
                                        value={caseSubTypeOptions.filter(
                                            (c) => c.value === caseSubTypeId
                                        )}
                                        filterOption={filterOption}
                                        options={caseSubTypeOptions}
                                        onChange={onCaseSubTypeChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <div className="mt-3">
                                <h5 className="font-14">Claim Amount</h5>
                                <div className="form-check">
                                    <input
                                        required={true}
                                        className="form-control"
                                        type="number"
                                        name="txtClaimAmount"
                                        id="txtClaimAmount"
                                        value={
                                            completeCoversheet.claimAmount ?? 0
                                        }
                                        onChange={(e) =>
                                            setCompleteCoversheet({
                                                ...completeCoversheet,
                                                claimAmount: parseInt(
                                                    e.currentTarget.value
                                                ),
                                            })
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                )}

                <div className="row mt-3">
                    <div className="col-12" style={{ textAlign: "center" }}>
                        <button
                            className="btn btn-primary"
                            type="button"
                            onClick={onSave}
                        >
                            Save
                        </button>
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col-12" style={{ textAlign: "center" }}>
                        <button
                            className="btn btn-success"
                            type="submit"
                            style={{
                                right: 24,
                                bottom: 40,
                                position: "absolute",
                            }}
                        >
                            Next
                            <i className="mdi mdi-arrow-right"></i>
                        </button>

                        <div style={{ color: "red" }}>{errorMessage}</div>
                    </div>
                </div>
            </form>
        </>
    );
}
